module.exports = __webpack_public_path__ + "assets/img/LTC018.29a3b65c.png";